<template>
  <div id="mobile-bottom-nav">
    <span id="overview" data-tesid="select-overview-mobile" class="nav-entry" @click="select('overview')" :class="{ selected: selectedMobileOption == 'overview' }">Overview</span>
    <span id="comments" data-tesid="select-comments-mobile" class="nav-entry" @click="select('comments')" :class="{ selected: selectedMobileOption == 'comments' }">Comments</span>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data: function(){
    return {
      selected: 'overview'
    }
  },
  computed: {
    ...mapState(['selectedMobileOption'])
  },
  methods: {
    select: function(option) {
      this.$store.commit('selectMobileOption', option);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/packs/application.scss';

#mobile-bottom-nav {
  background: white;
  position: fixed;
  z-index: 1;
  bottom: 0;
  width: 100%;
  display: none;
}

.nav-entry {
  padding: .5rem 0;
  cursor: pointer;
  flex: 1;
  text-align: center;
  border-top: 1px solid $white-four;
  color: $slate-gray;
  font-weight: 500;

  &.selected {
    color: $dark-gray;
    border-top: 1px solid $dark-gray;
  }
}

@media (max-width: 767px) {
  #mobile-bottom-nav {
    display: flex;
  }
}

</style>